module.exports = __webpack_public_path__ + "media/misc/military-logo-72bba55f.svg";